// extracted by mini-css-extract-plugin
export default {"form":"classes_form__iErtR","form-container":"classes_form-container__WFKyG","button-container":"classes_button-container__42KVe"};